export default __webpack_public_path__ + "static/media/girl-with-laptop.824ff1a3.svg";